export const navbarLinks = [
  { name: "Home", id: "top" },
  { name: "About me", id: "aboutme" },
  { name: "Skills", id: "skills" },
    { name: "Projects", id: "projects" },
  { name: "Experiences", id: "experiences" },
];
